import React from 'react';
import {Link, Route} from 'react-router-dom';
import classNames from 'classnames';

const NavbarLink = ({children, exact, to, ...props}) => (
    <Route exact={exact} path={to}>
        {({match}) => (
            <li className={classNames('nav-item', {active: match})}>
                <Link className="nav-link" exact={exact} to={to} {...props}>{children}</Link>
            </li>
        )}
    </Route>
);

export default NavbarLink;
